import { createContext } from 'react';

var InstantSearchServerContext = createContext(null);

export { InstantSearchServerContext };
